 export const blogs = [
    { label: "BLOG LIST", link: "blog-list", imgUrl: "url(assets/images/demo/blog-list.jpg)" },
    { label: "BLOG DETAILS ", link: "blog-details", imgUrl: "url(assets/images/demo/blog-details.jpg)" },
    { label: "BLOG LIST WITH SIDEBAR", link: "blog-leftside", imgUrl: "url(assets/images/demo/blog-list-left.jpg)" },
    { label: "BLOG LIST WITH RIGHT SIDEBAR", link: "blog-rightside", imgUrl: "url(assets/images/demo/blog-list-right.jpg)" },
    { label: "BLOG DETAILS WITH SIDEBAR", link: "blog-left-sidebar", imgUrl: "url(assets/images/demo/blog-details-left-sidebar.jpg)" },
    { label: "BLOG DETAILS WITH RIGHT SIDEBAR", link: "blog-right-sidebar", imgUrl: "url(assets/images/demo/blog-details-right-sidebar.jpg)" },
    { label: "SIGN IN", link: "sign-in", imgUrl: "url(assets/images/demo/sign-in.jpg)" },
    { label: "SIGN UP", link: "sign-up", imgUrl: "url(assets/images/demo/sign-up.jpg)" },
    { label: "FORGET PASSWORD", link: "forget-password", imgUrl: "url(assets/images/demo/forget.jpg)" },
    { label: "COMING SOON ", link: "coming-soon", imgUrl: "url(assets/images/demo/comingsoon.jpg)" },
    { label: "Request Schedule demo page", link: "request", imgUrl: "url(assets/images/demo/request.jpg)" },
    { label: "REVIEW", link: "review", imgUrl: "url(assets/images/demo/review.jpg)" },
    { label: "DOWNLOAD PAGE", link: "download", imgUrl: "url(assets/images/demo/download.jpg)" },
    { label: "FAQ PAGE", link: "faq", imgUrl: "url(assets/images/demo/faq.jpg)" },
    { label: "404 NOT PAGE", link: "404", imgUrl: "url(assets/images/demo/404.jpg)" },
    { label: "THANK YOU", link: "thank-you", imgUrl: "url(assets/images/demo/thankyou.jpg)" },
  ];

  export const features = [
    { label: "REACT", imgUrl: "assets/images/features/react.png" },
    { label: "CSS 3", imgUrl: "assets/images/features/css-3.png" },
    { label: "SCSS", imgUrl: "assets/images/features/sass.png" },
    { label: "FREE PSD", imgUrl: "assets/images/features/ps.png" },
    { label: "BOOTSTRAP 4", imgUrl: "assets/images/features/bootstrap-4.png" },
    { label: "ANIMATE CSS", imgUrl: "assets/images/features/animate-css.png" },
    { label: "RESPONSIVE", imgUrl: "assets/images/features/responsive.png" },
    { label: "GOOGLE FONTS SUPPORT", imgUrl: "assets/images/features/google-fonts-support.png" },
    { label: "W3C VALIDATION", imgUrl: "assets/images/features/w3c-validation.png" },
    { label: "PIXEL PERFECT DESIGN", imgUrl: "assets/images/features/pixel-perfect-design.png" },
    { label: "ALL BROWSER SUPPORT", imgUrl: "assets/images/features/all-broweser-support.png" },
    { label: "RTL (Coming soon)", imgUrl: "assets/images/features/rtl.png" },
  ];

  export const imageData = [
    { className: 'mobile-slid', src: 'assets/images/demo/home/weightlifting.png', alt: 'weightlifting' },
    { className: 'photo', src: 'assets/images/demo/home/photo-Editing-app.png', alt: 'photo editing app' },
    { className: 'gym', src: 'assets/images/demo/home/gym-app.png', alt: 'gym app' },
    { className: 'game', src: 'assets/images/demo/home/game-app.png', alt: 'game app' },
    { className: 'msg', src: 'assets/images/demo/home/messanger.png', alt: 'messenger' },
    { className: 'broweser', src: 'assets/images/demo/home/browser.png', alt: 'browser' },
    { className: 'love-emoji', src: 'assets/images/top5.png', alt: 'love emoji' },
  ];

   export const TemplateimageData = [
    { className: 'mobile-slid', src: 'assets/images/top-mobile.png', alt: 'top1' },
    { className: 'profile-msg', src: 'assets/images/top2.png', alt: 'top2' },
    { className: 'awesome', src: 'assets/images/top3.png', alt: 'top3' },
    { className: 'emoji', src: 'assets/images/top5.png', alt: 'top5' },
    { className: 'profile-2', src: 'assets/images/top1.png', alt: 'top1' },
  ];